import "./consentElementBlock.scss";
import { initShowMore } from "./consentElementBlockShowMore";

initShowMore();